import { useCallback } from "react";

const useFocusTrap = (containerRef, handleEscape) => {
    return useCallback((e) => {

            const container = containerRef?.current;
            if(!container) return;
            
            const focusableSelectors = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
            const focusableEls  = container.querySelectorAll(focusableSelectors);

            if (!focusableEls || focusableEls.length === 0) return;


            const firstElement = focusableEls[0];
            const lastElement = focusableEls[focusableEls.length - 1];

            if (e.key === "Tab") {
                if (e.shiftKey && document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                } else if (!e.shiftKey && document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }

            if (e.key === "Escape") {
                e.preventDefault();
                handleEscape(e);
            }

    }, [containerRef, handleEscape]);
};

export default useFocusTrap;